import { render, staticRenderFns } from "./QuestionBulkUpdater.vue?vue&type=template&id=658d1f7e&scoped=true"
import script from "./QuestionBulkUpdater.vue?vue&type=script&lang=ts"
export * from "./QuestionBulkUpdater.vue?vue&type=script&lang=ts"
import style0 from "./QuestionBulkUpdater.vue?vue&type=style&index=0&id=658d1f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658d1f7e",
  null
  
)

export default component.exports